import { z, isoZ } from 'my-zod'
import { attachmentModel } from '../../utilities/attachment'
import { enumOptionsToObject } from '../../internal'

export const CommunicationsLogActivityTypeEnum = z
  .enum(['Note', 'Call', 'Email', 'OnSiteVisit', 'AccountsReceivable'])
  .setEnumLabels({
    Note: 'Note',
    Call: 'Call',
    Email: 'Email',
    OnSiteVisit: 'On-site Visit',
    AccountsReceivable: 'Accounts Receivable'
  })

export type CommunicationsLogActivityType = z.infer<typeof CommunicationsLogActivityTypeEnum>

export const communicationLogTagsOptions = [
  'PastDueProgram',
  'PastDuePGA',
  'DemandGenerationMarketing',
  'DamageWaiversParts',
  'FleetVehicles',
  'PerformanceConcerns',
  'TechnologyConcern',
  'FollowUpItem',
  'BusinessPlan',
  'Disposition',
  'Insurance'
] as const

export const communicationLogTags = enumOptionsToObject(communicationLogTagsOptions)
export type CommunicationLogTags = (typeof communicationLogTagsOptions)[number]

export const communicationLogTagsLabels = {
  PastDueProgram: 'Past Due – Program',
  PastDuePGA: 'Past Due – PG&A',
  DemandGenerationMarketing: 'Demand generation/Marketing',
  DamageWaiversParts: 'Damage Waivers/Parts',
  FleetVehicles: 'Fleet/Vehicles',
  PerformanceConcerns: 'Performance Concerns',
  TechnologyConcern: 'Technology Concern',
  FollowUpItem: 'Follow Up Item',
  BusinessPlan: 'Business Plan',
  Disposition: 'Disposition',
  Insurance: 'Insurance'
} as Record<CommunicationLogTags, string>

export const outfitterCommunicationsLogModel = z.object({
  id: z.string().uuid(),
  shortId: z.string(),
  ownerId: z.number().nullable(),
  title: z.string().max(255).nonempty(),
  activityType: CommunicationsLogActivityTypeEnum,
  outfitterIds: z.number().array(),
  contactIds: z.string().array(),
  communicationDate: isoZ.date(),
  attachments: attachmentModel.array(),
  text: z.string().nullable(),
  tags: z.enum(communicationLogTagsOptions).array().nullable(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type outfitterCommunicationsLogModel = z.infer<typeof outfitterCommunicationsLogModel>
